import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  standalone: true,
  selector: 'app-hpp-dialog',
  template: `
    <div class="hpp-shell">
      <!-- Top bar -->
      <div class="hpp-header">
        <div class="hpp-title">Secure Debit Card Payment</div>
      </div>

      <!-- Iframe content -->
      <iframe
        class="hpp-frame"
        [src]="safeUrl"
        title="Hosted Payment Page"
        referrerpolicy="no-referrer"
      ></iframe>

      <!-- Bottom bar -->
      <div class="hpp-footer">
        <button mat-stroked-button type="button" (click)="close()">
          Cancel
        </button>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .hpp-shell {
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #fff;
      }

      /* ───── Top bar ───── */
      .hpp-header {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        padding: 12px 16px;
        background: #fff;
        color: #111;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }

      .hpp-title {
        font-weight: 500;
        font-size: 16px;
      }

      /* ───── Iframe ───── */
      .hpp-frame {
        flex: 1 1 auto;
        width: 100%;
        border: 0;
        background: #fff;
      }

      /* ───── Bottom bar ───── */
      .hpp-footer {
        flex: 0 0 auto;
        display: flex;
        justify-content: flex-end;
        padding: 12px 16px;
        background: #fff;
        border-top: 1px solid rgba(0, 0, 0, 0.12);
      }

      /* Stylize nicely – consistent in light & dark mode */
      .hpp-footer button {
        background: #fff;
        color: #111;
        border: 1px solid rgba(0, 0, 0, 0.23);
        font-weight: 500;
        text-transform: none; /* no ALL CAPS */
        padding: 6px 16px;
        border-radius: 6px;
      }

      /* Hover */
      .hpp-footer button:hover {
        background: rgba(0, 0, 0, 0.04);
        cursor: pointer;
      }

      /* Focus / keyboard */
      .hpp-footer button:focus-visible {
        outline: 2px solid #1976d2; /* Material blue */
        outline-offset: 2px;
      }

      /* Disabled (if you ever add it) */
      .hpp-footer button:disabled {
        color: rgba(0, 0, 0, 0.38);
        border-color: rgba(0, 0, 0, 0.12);
      }
    `,
  ],
})
export class HppDialogComponent implements OnInit, OnDestroy {
  safeUrl!: SafeResourceUrl;

  private onMessage = (evt: MessageEvent) => {
    if (evt.origin !== 'https://dev-portal.transend.io') return; // lock it down

    if (evt.data?.type === 'HPP_RESULT') {
      this.dialogRef.close(evt.data); // ✅ closes modal
    }
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { url: string },
    private dialogRef: MatDialogRef<HppDialogComponent>,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
    window.addEventListener('message', this.onMessage);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.onMessage);
  }

  close() {
    this.dialogRef.close({ type: 'HPP_RESULT', status: 'cancel' });
  }
}
